<input
  class="input w-full block py-2.5 mt-1 px-4 border outline-1 appearance-none border-solid rounded-md border-smoke text-night-darker focus:border-grass-darker"
  matInput
  type="text"
  [(ngModel)]="autocompleteInput"
  #addresstext
  [attr.placeholder]="placeholder" />
